import * as Cookie from 'app/packages/cookie-utils';

export default function getOrSetVisitCookie() {
  let firstVisit = false;
  if (!Cookie.get(PCONST.COOKIE_SESSION_FUNNEL_EVENT_LOGGED)) {
    Cookie.set(PCONST.COOKIE_SESSION_FUNNEL_EVENT_LOGGED, '1', 12);
    firstVisit = true;
  }

  return firstVisit;
}
